<div class="loading-indicator backDrop cardParent">
	<div class="card">
		<span id="app-loading-message">{{app.appLoadingMessage$ | async}}</span>
		<i class="far fa-spin fa-spinner-third text-info spinner"></i>
	</div>
</div>
